<div class="autocomplete">
  <div class="input-icon">
      <input [(ngModel)]="input" 
             class="form-control" 
             type="text"
             (keyup)="getAllItems()"
             (keydown.enter)="onManualInput()" 
             (ngModelChange)="onInputChange()"
             placeholder="{{placeholder || 'Pretraži'}}">
      <div class="input-icon-addon">
          <i class="fe fe-search"></i>
      </div>
  </div>
  <div class="font-size-sm text-danger" *ngIf="input && !isListVisible && !isManualInputClientConfirmed">*Pritisnite Enter da potvrdite unos</div>

  <div class="autocomplete__list" *ngIf="isListVisible">
      <div class="autocomplete__item"
           *ngFor="let item of items; trackBy: trackByFn"
           (click)="onSelect(item)">
          {{ item.name }}
      </div>
  </div>
</div>
